import { createFileRoute } from '@tanstack/react-router';

import { useLegalEntityContext } from '@/context/LegalEntityContext';
import { LegalEntityDetail } from '@/features/legal-entities/LegalEntityDetail';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/company/')({
  component: CompanyOverviewPage,
  head: () => buildHead('company'),
});

function CompanyOverviewPage() {
  const { activeEntity } = useLegalEntityContext();

  if (!activeEntity) return null;

  return <LegalEntityDetail entityId={activeEntity.id} hideHeader hideStaffSection />;
}
